import React, { useEffect, useState } from "react";
import "./CourseCard.css";
import StyledMenu from "../StyleMenu";
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router";
import {
  alert_image,
  archive_btn,
  warning_blue_img,
} from "../../assets/images/images";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCourseById,
  resetdeleteCourse,
} from "../../state/actions/deleteCourseAction";
import { useAuth } from "../../features/auth/AuthContext";
import Loader from "../FileRepo/Components/Loader";
import { toast } from "react-toastify";
import { getAllCoursesByTeacherId } from "../../state/actions/getAllCoursesByTeacherIdAction";
import { updateGlobalState } from "../../state/global/slice";
import api from "../../api/api";
// import CourseItem from "../../context/CourseDescriptionPreview";
import DescriptionCoursePopup from "../../pages/home/components/dashboard/teacher/course/DescriptionCoursePopup";
import CourseDescriptionPreview from "../../context/CourseDescriptionPreview";

function CourseCard({
  course = [],
  courseimage,
  coursename,
  schooljoined,
  totalstudents,
  totalteachers,
  createdcourse,
  description,
  course_info_image,
  Teacher_name,
  Teacher_title,
  Sales_Courses_title,
  checkbox,
  location,
  location_name,
  course_details,
}) {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [deletePopUp, setdeletePopUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenuCourseId, setActiveMenuCourseId] = useState(null);
  const [archiveCourse, setArchiveCourse] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [archiveAction, setArchiveAction] = useState({
    courseId: null,
    isArchived: false,
  });
  const { token } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const deletedCourseById = useSelector((state) => state.deleteCourseById);
  const globalState = useSelector((state) => state.globalState);
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;
  const onViewCourseClick = async (course_details) => {
    navigate(`/course/${course_details.course_id}/view`, {
      state: {
        course: course_details,
        teacher_id: course_details.teacher_id,
        backToCourses: true,
      },
    });
  };
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  const onEditCourseClick = async (course) => {
    navigate(`/course/${course.course_id}/edit`, {
      state: {
        course: course_details,
        teacher_id: course_details.teacher_id,
        backToCourses: true,
      },
    });
  };

  const handleClick = (event, courseId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenuCourseId(courseId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveMenuCourseId(null);
  };

  const deleteCourse = async (course_id) => {
    setSelectedCourse(course_id);
    setdeletePopUp(!deletePopUp);
    handleClose();
  };

  const handleDeleteCourse = () => {
    setdeletePopUp(!deletePopUp);
    dispatch(deleteCourseById(selectedCourse, token));
  };

  useEffect(() => {
    if (deletedCourseById?.message?.length) {
      dispatch(resetdeleteCourse());
    }
  }, [deletedCourseById]);

  useEffect(() => {
    return () => {
      dispatch(resetdeleteCourse());
    };
  }, []);
  const onteacherViewProfile = (tid) => {
    navigate(`/TeacherProfile/${tid}`, {
      state: { teacher_id: tid, from: location.pathname },
    });
  };
  const toggleArchiveCourse = (courseId = null, isArchived = false) => {
    setArchiveAction({ courseId, isArchived });
    setArchiveCourse((prev) => !prev);
    setArchiveLoading(false);
    document.body.style.overflow = "auto";
  };
  const handleArchiveCourse = async () => {
    const { courseId, isArchived } = archiveAction;
    if (!courseId) return;
    setArchiveLoading(true);
    document.body.style.overflow = "auto";
    try {
      const response = await api.post(
        `/courses/${courseId}/archive/`,
        { is_archived: !isArchived },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      );
      if (response.status === 200) {
        setArchiveLoading(false);
        const course_list = globalState.course_list?.map((course) =>
          course.course_id === courseId
            ? { ...course, is_archived: !isArchived }
            : course,
        );
        updateState("course_list", course_list);
        dispatch(getAllCoursesByTeacherId("1", teacher_id, token));

        toast.success(
          <div>
            <div className="font-bold">
              {isArchived
                ? "Course Restored Successfully"
                : "Course Archived Successfully"}
            </div>

            <div className="mt-1">
              {isArchived ? (
                <>“{selectedCourse}” has been moved back to Active Courses</>
              ) : (
                <>
                  You can access the archived course, “{selectedCourse},” from
                  the Total Courses → Archive tab.
                </>
              )}
            </div>
          </div>,
          {
            containerId: "archive-toast",
          },
        );
        setTimeout(() => {
          setArchiveCourse(false);
        }, 700);
      } else {
        setArchiveLoading(false);
        setArchiveCourse(false);
        toast.error("Something went wrong. Please Try Again", {
          position: "top-center",
        });
      }
    } catch (error) {
      setArchiveLoading(false);
      setArchiveCourse(false);
      toast.error("Something went wrong.", {
        position: "top-center",
      });
    }
  };
  return (
    <>
      <div className="created-my-courses-folder">
        <div className="created-my-courses-folder-image-left-folder">
          <div
            className="created-my-courses-folder-image"
            onClick={() => onViewCourseClick(course_details)}
          >
            <img src={courseimage} alt="" />
          </div>
        </div>
        <div className="created-my-courses-des-wrapper">
          <div className="created-my-courses-title-folder ">
            <div className="course-inner-title-wrapper">
              <div
                className="created-my-courses-title-wrapper"
                onClick={() => onViewCourseClick(course_details)}
              >
                <h2 className="school_title">{coursename} </h2>
                {globalState.enabled_modules?.includes('marketplace') && (
                      <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                            <a> <i className="fa-solid fa-star"></i> </a>
                            <p className="rate">{course_details?.average_course_rating || "0"}</p>
                            <p className="number">({parseInt(course_details?.rating_count || 0)})</p>
                      </div>
                )} 
              </div>
            </div>
            <div
              className="edit-course-dropdown-menu-container"
              style={{ cursor: "pointer" }}
            >
              <div
                className="edit-course-or-delete-course"
                onClick={(e) => handleClick(e, course_details.course_id)}
              >
                <i className="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <StyledMenu
                id="demo-customized-menu"
                anchorEl={anchorEl}
                open={Boolean(
                  anchorEl && activeMenuCourseId === course_details.course_id,
                )}
                onClose={handleClose}
              >
                <MenuItem
                  onClick={() => {
                    if (activeMenuCourseId === course_details.course_id) {
                      onEditCourseClick(course_details);
                    }
                    handleClose();
                  }}
                  disableRipple
                >
                  <button
                    type="button"
                    className="course-edit-or-delete-folder"
                  >
                    <a href="#">
                      <i className="fa-solid fa-pencil"></i>
                    </a>
                    <p>Edit</p>
                  </button>
                </MenuItem>
                {(course.my_role === "owner" || globalState.role === "Admin") &&
                  globalState.enabled_modules?.includes("year2year") && (
                    <MenuItem
                      onClick={() => {
                        if (activeMenuCourseId === course.course_id) {
                          setSelectedCourse(course.name); // optional for toast
                          toggleArchiveCourse(
                            course.course_id,
                            course.is_archived,
                          );
                        }
                        handleClose();
                      }}
                      disableRipple
                    >
                      <button
                        type="button"
                        className="course-edit-or-delete-folder"
                      >
                        <img
                          className="h-4 w-4"
                          src={archive_btn}
                          alt="archive_btn"
                        />
                        <p>
                          {course.is_archived ? "Unarchive" : "Archive"} Course
                        </p>
                      </button>
                    </MenuItem>
                  )}
                <MenuItem
                  onClick={() => {
                    if (activeMenuCourseId === course_details.course_id) {
                      deleteCourse(course_details.course_id);
                    }
                    handleClose();
                  }}
                  disableRipple
                >
                  <button
                    type="button"
                    className="course-edit-or-delete-folder"
                  >
                    <a href="#">
                      <i className="fa-solid fa-trash"></i>
                    </a>
                    <p>Delete</p>
                  </button>
                </MenuItem>
              </StyledMenu>
            </div>
          </div>
          <div className="Students-courses-details-container">
            <div className="Students-courses-details-folder course_inner_tab_details">
              <span>Total Students</span>
              <div className="Students-courses-details-counts">
                <p>{totalstudents}</p>
              </div>
            </div>
            <div className="Students-courses-details-folder course_inner_tab_details">
              <span>Total Teachers</span>
              <div className="Students-courses-details-counts">
                <p>{totalteachers}</p>
              </div>
            </div>
            <div className="Students-courses-details-folder course_inner_tab_details">
              <span>Created Course</span>
              <div className="Students-courses-details-counts">
                <p>{createdcourse}</p>
              </div>
            </div>
          </div>
          {/* <p className="Students-des">{description}</p> */}
          {/* <CourseItem key={course_details.course_id} course={course_details} /> */}
          <CourseDescriptionPreview
            description={description}
            PopupComponent={DescriptionCoursePopup}
            popupTitle="My Course Description"
          />
          <div className="course-main-container">
            <div
              className={
                Teacher_name?.length > 0
                  ? "course-inner-info"
                  : "course-inner-without-info"
              }
            >
              <div
                className={
                  course_info_image?.length > 0
                    ? "course-inner-info-with-image"
                    : "course-inner-info-without-image"
                }
              >
                <img src={course_info_image} alt="" />
              </div>
              <div className="course-inner-info-title">
                <h2
                  onClick={() => {
                    onteacherViewProfile(course_details.teacher_id);
                  }}
                >
                  {Teacher_name}
                </h2>
                <p
                  onClick={() => {
                    onteacherViewProfile(course_details.teacher_id);
                  }}
                >
                  {Teacher_title}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="View-Course"
              onClick={() => onViewCourseClick(course_details)}
            >
              View Course
            </button>
          </div>
        </div>
      </div>

      {deletePopUp && (
        <form action="" className="delete-course-form">
          <div className="delete-course-form-container">
            <div className="delete-course-alert-image">
              <img src={alert_image} alt="" />
            </div>
            <h2>Are you sure you want to delete this course?</h2>
            <div className="delete-course-form-btn-folder">
              <button
                type="button"
                onClick={() => setdeletePopUp(!deletePopUp)}
                className="not-delete-btn"
              >
                No
              </button>
              {loading ? (
                <div className="loading-spinner" />
              ) : (
                <button
                  type="button"
                  onClick={handleDeleteCourse}
                  disabled={loading}
                  className="delete-btn"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </form>
      )}
      {archiveCourse && (
        <form action="" className="delete-course-form">
          <div
            className="delete-course-form-container relative"
            data-aos="zoom-in"
          >
            {archiveLoading && (
              <div className="absolute inset-0 z-50 flex items-center justify-center bg-white rounded-xl">
                <Loader />
              </div>
            )}

            <div className="delete-course-alert-image">
              <img src={warning_blue_img} alt="" />
            </div>

            <h2>
              Are you sure you want to{" "}
              {archiveAction.isArchived ? "unarchive" : "archive"} this course?
            </h2>

            <div className="delete-course-form-btn-folder">
              <button
                type="button"
                onClick={() => toggleArchiveCourse()}
                disabled={archiveLoading}
                className="border-[#0068FF] bg-white text-[#0068FF]"
              >
                No
              </button>

              <button
                type="button"
                onClick={handleArchiveCourse}
                disabled={archiveLoading}
                className="border-[#0068FF] text-white bg-[#0068FF]"
              >
                {archiveAction.isArchived ? "Unarchive" : "Archive"}
              </button>
            </div>
          </div>
        </form>
      )}
    </>
  );
}

export default CourseCard;
